var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Router } from '@angular/router';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
var StatusRequestDocumentComponent = /** @class */ (function () {
    function StatusRequestDocumentComponent(router, apiService, util) {
        this.router = router;
        this.apiService = apiService;
        this.util = util;
        this.lang = "th-TH";
        this.crm08DROSList = [];
    }
    StatusRequestDocumentComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs, PortalUser, accNo, _a, _b, _c, _i, _d, itm, docStatus, rowDisplay, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        this.lang = this.util.GetCurrentLang();
                        thisTs = this;
                        PortalUser = JSON.parse(localStorage.getItem("dpa_portal"));
                        if (PortalUser == null || PortalUser.contactid == null || PortalUser.contactid == "") {
                            this.util.WarningDialog("กรุณาเข้าสู่ระบบ");
                            $("#btnWarningOK").off("click");
                            $("#btnWarningOK").click(function () {
                                thisTs.router.navigate(["/mainmenu/login"]);
                            });
                            return [2 /*return*/];
                        }
                        this.util.ShowWaiting(true);
                        this.cookieData = JSON.parse(localStorage.getItem("dpa_portal"));
                        if (this.cookieData == null) {
                            this.cookieData = {};
                        }
                        accNo = localStorage.getItem("acccountNo");
                        _a = this;
                        return [4 /*yield*/, this.getContact()];
                    case 1:
                        _a.contact = _f.sent();
                        _b = this;
                        return [4 /*yield*/, this.getContactDROS(this.contact.dpa_idcard)];
                    case 2:
                        _b.contactDROS = _f.sent();
                        if (!!this.util.IsNullOrUndefined(this.contactDROS.CRM06)) return [3 /*break*/, 4];
                        _c = this;
                        return [4 /*yield*/, this.getCRM08DROS(this.contactDROS.CRM06.UID)];
                    case 3:
                        _c.crm08DROS = _f.sent();
                        if (!this.util.IsNullOrUndefined(this.crm08DROS) && this.crm08DROS.length > 0) {
                            for (_i = 0, _d = this.crm08DROS; _i < _d.length; _i++) {
                                itm = _d[_i];
                                if (itm.DROSRequestNo == accNo) {
                                    docStatus = void 0;
                                    if (itm.SentStatus === "1") {
                                        docStatus = "ส่งสำเร็จ";
                                    }
                                    else if (itm.PrintStatus === "1") {
                                        docStatus = "อยู่ระหว่างจัดพิมพ์";
                                    }
                                    else if (itm.IsRead === "1") {
                                        docStatus = "ได้รับข้อมูล";
                                    }
                                    else {
                                        docStatus = "ยื่นคำขอเอกสารใหม่";
                                    }
                                    rowDisplay = { CRMRequestNo: itm.CRMRequestNo, DROSRequestNo: itm.DROSRequestNo, DocumentCode: itm.DocumentCode, UID: itm.UID, Status: itm.Status, ErrorCode: itm.ErrorCode, Address: itm.Address, MooNo: itm.MooNo, StreetName: itm.StreetName, LocationCode: itm.LocationCode, Zipcode: itm.Zipcode, PhoneNo: itm.PhoneNo, Email: itm.Email, CreateOn: this.DisplayDate(itm.CreateOn), ModifiedOn: itm.ModifiedOn, ProcessStatus: docStatus };
                                    this.crm08DROSList.push(rowDisplay);
                                }
                            }
                        }
                        _f.label = 4;
                    case 4:
                        _e = this;
                        return [4 /*yield*/, this.getAddressAll()];
                    case 5:
                        _e.combinedAddressList = _f.sent();
                        localStorage.setItem('acccountNo', null);
                        this.util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    StatusRequestDocumentComponent.prototype.getContact = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        para = "contactid=" + this.cookieData.contactid;
                        return [4 /*yield*/, this.apiService.get("crmservice", "contact", para)];
                    case 1:
                        tmp = _a.sent();
                        return [2 /*return*/, tmp[0]];
                }
            });
        });
    };
    StatusRequestDocumentComponent.prototype.getContactDROS = function (idcard) {
        return __awaiter(this, void 0, void 0, function () {
            var para, tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        para = "dpa_id=" + idcard + "&telephoneno=&fullname=&CRM05=false&CRM04=false&CRM03=false&CRM02=false&CRM07=false";
                        return [4 /*yield*/, this.apiService.get("crmservice", "contactDros", para)];
                    case 1:
                        tmp = _a.sent();
                        return [2 /*return*/, tmp];
                }
            });
        });
    };
    StatusRequestDocumentComponent.prototype.getCRM08DROS = function (uid) {
        return __awaiter(this, void 0, void 0, function () {
            var para, tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        para = "UID=" + uid;
                        return [4 /*yield*/, this.apiService.get("crmservice", "getCRM08DROS", para)];
                    case 1:
                        tmp = _a.sent();
                        return [2 /*return*/, tmp];
                }
            });
        });
    };
    StatusRequestDocumentComponent.prototype.getAddressAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService.getMasterAddress()];
                    case 1:
                        tmp = _a.sent();
                        return [2 /*return*/, tmp];
                }
            });
        });
    };
    StatusRequestDocumentComponent.prototype.DisplayDate = function (sdate) {
        var result = "";
        var enDate = sdate.split('T')[0].split('-');
        if (this.lang === "th-TH") {
            result = enDate[2] + "/" + enDate[1] + "/" + (parseInt(enDate[0]) + 543).toString();
        }
        else {
            result = enDate[2] + "/" + enDate[1] + "/" + enDate[0];
        }
        return result;
    };
    StatusRequestDocumentComponent.prototype.ShowDetail = function (drosReqNo) {
        var objDetail = this.crm08DROSList.find(function (e) { return e.DROSRequestNo === drosReqNo; });
        if (!this.util.IsNullOrUndefined(objDetail.ErrorMessage)) {
            this.util.WarningDialog(objDetail.ErrorMessage);
        }
        var addr = this.combinedAddressList.filter(function (a) { return a.id.split('|')[0] == objDetail.LocationCode; });
        $("#lblFullname").empty().text(this.contactDROS.CRM06.Name);
        $("#lblPhoneNo").empty().text(objDetail.PhoneNo);
        $("#lblDROSReqNo").empty().text(objDetail.DROSRequestNo);
        var fullAdress = "";
        if (!this.util.IsNullOrUndefined(objDetail.Address)) {
            fullAdress += objDetail.Address;
        }
        if (!this.util.IsNullOrUndefined(objDetail.MooNo)) {
            fullAdress += " หมู่ที่ " + objDetail.MooNo;
        }
        if (!this.util.IsNullOrUndefined(objDetail.StreetName)) {
            fullAdress += " ถนน" + objDetail.StreetName;
        }
        if (addr.length > 0) {
            var tmpAddr = addr[0].text.split('|');
            for (var i = 0; i < tmpAddr.length; i++) {
                if (i == 0) {
                    fullAdress += " แขวง/ตำบล " + tmpAddr[i];
                }
                if (i == 1) {
                    fullAdress += " เขต/อำเภอ " + tmpAddr[i];
                }
                if (i == 2) {
                    fullAdress += " จังหวัด" + tmpAddr[i];
                }
                if (i == 3) {
                    fullAdress += tmpAddr[i] == objDetail.Zipcode ? " ไปรษณีย์ " + tmpAddr[i] : " ไปรษณีย์ " + objDetail.Zipcode;
                }
                if (i == 4) {
                    fullAdress += " ประเทศ " + tmpAddr[i];
                }
            }
        }
        $("#lblAddress").empty().text(fullAdress);
        switch (objDetail.ProcessStatus) {
            case "ส่งสำเร็จ": {
                $("#imgStatus01").attr("src", "../../assets/images/reqDocStatus01_active.png");
                $("#imgStatus02").attr("src", "../../assets/images/reqDocStatus02_active.png");
                $("#imgStatus03").attr("src", "../../assets/images/reqDocStatus03_active.png");
                break;
            }
            case "อยู่ระหว่างจัดพิมพ์": {
                $("#imgStatus01").attr("src", "../../assets/images/reqDocStatus01_active.png");
                $("#imgStatus02").attr("src", "../../assets/images/reqDocStatus02_active.png");
                $("#imgStatus03").attr("src", "../../assets/images/reqDocStatus03.png");
                break;
            }
            case "ยื่นคำขอเอกสารใหม่":
            case "ได้รับข้อมูล": {
                $("#imgStatus01").attr("src", "../../assets/images/reqDocStatus01_active.png");
                $("#imgStatus02").attr("src", "../../assets/images/reqDocStatus02.png");
                $("#imgStatus03").attr("src", "../../assets/images/reqDocStatus03.png");
                break;
            }
            default: {
                $("#imgStatus01").attr("src", "../../assets/images/reqDocStatus01.png");
                $("#imgStatus02").attr("src", "../../assets/images/reqDocStatus02.png");
                $("#imgStatus03").attr("src", "../../assets/images/reqDocStatus03.png");
                break;
            }
        }
        $("#frmStatusReqNewDoc").removeClass("animate-opacity").addClass("hideDiv");
        $("#divDetail").removeClass("hideDiv").addClass("animate-opacity");
        //console.log(objDetail);
        // console.log(this.contactDROS.CRM06);
    };
    StatusRequestDocumentComponent.prototype.BackToList = function () {
        $("#divDetail").removeClass("animate-opacity").addClass("hideDiv");
        $("#frmStatusReqNewDoc").removeClass("hideDiv").addClass("animate-opacity");
    };
    StatusRequestDocumentComponent.prototype.BackToReDoc = function () {
        this.router.navigate(["/mainmenu/reqNewDocument"]);
    };
    return StatusRequestDocumentComponent;
}());
export { StatusRequestDocumentComponent };



// WEBPACK FOOTER //
// ./src/app/status-request-document/status-request-document.component.ts.pre-build-optimizer.js